// import { getAuthenticatedToken } from '../../../services/authToken';

import { PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';

import {
  getRoadMapAIResponsesValues,
  upsertRoadmapAiResponses,
} from '../../../services/database/ai-roadmap';
import { AppDispatch } from '../../store';

import { updateUsersRoadmapAiResponsesAction } from './roadmap-ai.slice';
import { AlternateCareer, UserCareerRoadmap, UserData } from './roadmap-ai.type';

export const dispatchUpsertRoadMapAiResponse =
  (dto?: UserCareerRoadmap) =>
  async (dispatch: AppDispatch): Promise<void> => {
    if (!dto) return;

    try {
      const userData = await upsertRoadmapAiResponses(dto);

      dispatch(updateUsersRoadmapAiResponsesAction(userData));
    } catch (error) {
      console.error('Failed to dispatch roadmap AI response:', error);
    }
  };

export const dispatchGetLatestRoadmapAI =
  () =>
  async (dispatch: Dispatch<PayloadAction<UserData>>): Promise<UserData | undefined> => {
    const values: UserData | undefined = await getRoadMapAIResponsesValues();
    if (values) {
      dispatch(updateUsersRoadmapAiResponsesAction(values));
    }
    return values;
  };

export const extractUniqueTopSkillsDiverse = (alternateCareers: AlternateCareer[]): string[] => {
  const seen = new Set<string>();
  const uniqueSkills: string[] = [];

  for (const career of alternateCareers) {
    let picked = 0;

    for (const skill of career.required_skills.slice(0, 2)) {
      const normalized = skill.toLowerCase().trim();
      if (!seen.has(normalized)) {
        seen.add(normalized);
        uniqueSkills.push(skill);
        picked++;
      }

      // Ensure at least one skill from each career
      if (picked >= 1) continue;
    }
  }

  return uniqueSkills;
};

export const currencyConvertor = (input: string | number | undefined): number => {
  if (typeof input === 'number') return input; // already numeric

  if (!input) return 0;

  // Remove currency symbols ($, ₹, €, etc.), commas, and spaces
  const sanitized = input
    .toString()
    .replace(/[^\d.-]/g, '') // keep only digits, dot, and minus
    .trim();

  // Convert to number
  const value = parseFloat(sanitized);

  // Handle invalid values gracefully
  return isNaN(value) ? 0 : value;
};
